import { render, staticRenderFns } from "./ResultsByPrice.vue?vue&type=template&id=7f1d74b7&scoped=true&"
import script from "./ResultsByPrice.vue?vue&type=script&lang=js&"
export * from "./ResultsByPrice.vue?vue&type=script&lang=js&"
import style0 from "./ResultsByPrice.vue?vue&type=style&index=0&id=7f1d74b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1d74b7",
  null
  
)

export default component.exports